import React from "react";
import { Modal } from "./Modal";
import { Link } from "react-router-dom";

interface AuthRequiredModalProps {
  isVisible: boolean;
  onClose: () => void;
}

export const AuthRequiredModal: React.FC<AuthRequiredModalProps> = ({
  isVisible,
  onClose,
}) => {
  return (
    <Modal
      isVisible={isVisible}
      onClose={onClose}
      title="Authentication Required"
    >
      <div className="flex flex-col gap-4">
        <p className="text-gray-300">
          Backtesting is only available for registered users. Please log in or
          create an account to continue.
        </p>
        <div className="flex justify-end gap-3 mt-4">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-300 hover:text-white transition-colors"
          >
            Cancel
          </button>
          <Link
            to="/sign-in"
            className="px-4 py-2 text-sm font-medium bg-slate-700 text-white rounded hover:bg-slate-600 transition-colors"
          >
            Log In
          </Link>
          <Link
            to="/sign-up"
            className="px-4 py-2 text-sm font-medium bg-blue-600 text-white rounded hover:bg-blue-500 transition-colors"
          >
            Register
          </Link>
        </div>
      </div>
    </Modal>
  );
};
